import React from 'react';

// Renders a screenshot with numbered circle markers and arrows pointing at
// specific spots, plus a matching numbered caption list underneath. All
// coordinates in `annotations` are percentages (0-100) of the image's width/
// height, so markers stay correctly placed at any screen size.
//
// annotations: [{ x, y, text, from: { x, y } }]
//   x/y   — where the numbered circle sits (usually just outside the target)
//   from  — (optional) tail of the arrow; the arrow points from `from` to `x,y`
//   text  — caption shown in the numbered list below the image
export default function AnnotatedImage({ src, alt, annotations = [] }) {
  if (!src) {
    return (
      <div className="border border-dashed border-gray-300 bg-gray-50 aspect-video flex items-center justify-center text-sm text-gray-400">
        Screenshot pending
      </div>
    );
  }

  return (
    <div>
      <div className="relative inline-block w-full border border-gray-200 shadow-sm">
        <img src={src} alt={alt} className="w-full h-auto block select-none" draggable={false} />
        <svg
          className="absolute inset-0 w-full h-full pointer-events-none"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
        >
          <defs>
            <marker id="help-arrowhead" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
              <path d="M0,0 L8,4 L0,8 Z" fill="#c8a84b" />
            </marker>
          </defs>
          {annotations.filter(a => a.from).map((a, i) => (
            <line
              key={i}
              x1={a.from.x} y1={a.from.y} x2={a.x} y2={a.y}
              stroke="#c8a84b" strokeWidth="0.6"
              markerEnd="url(#help-arrowhead)"
            />
          ))}
        </svg>
        {annotations.map((a, i) => (
          <div
            key={i}
            className="absolute -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-6 h-6 rounded-full bg-accent text-white text-xs font-bold shadow ring-2 ring-white"
            style={{ left: `${a.x}%`, top: `${a.y}%` }}
          >
            {i + 1}
          </div>
        ))}
      </div>
      {annotations.length > 0 && (
        <ol className="mt-3 space-y-1.5 text-sm text-gray-600">
          {annotations.map((a, i) => (
            <li key={i} className="flex gap-2.5">
              <span className="shrink-0 w-5 h-5 mt-0.5 rounded-full bg-accent text-white text-[11px] font-bold flex items-center justify-center">
                {i + 1}
              </span>
              <span>{a.text}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
